import type { CaminoUpdateRequest, CaminoView } from '@/types/camino';
import type { CaminoMemberImportRun } from '@/types/caminoMemberImport';
import { ApiService } from './api.service';

class CaminoService extends ApiService {
  public async getCamino(churchId: string): Promise<CaminoView> {
    const url = `/api/v1/churches/${churchId}/camino`;
    const response = await this.get<CaminoView>(url);
    return response.data;
  }

  public async updateCamino(churchId: string, payload: CaminoUpdateRequest): Promise<CaminoView> {
    const url = `/api/v1/churches/${churchId}/camino`;
    const response = await this.put<CaminoView>(url, payload);
    return response.data;
  }

  public async getCaminoMemberImports(churchId: string): Promise<CaminoMemberImportRun[]> {
    const url = `/api/v1/churches/${churchId}/camino-member-imports`;
    const response = await this.get<CaminoMemberImportRun[]>(url);
    return response.data;
  }

  public async startCaminoMemberImport(churchId: string, file: File): Promise<CaminoMemberImportRun> {
    const url = `/api/v1/churches/${churchId}/camino-member-imports`;
    const formData = new FormData();
    formData.append('csv', file);
    // Let the browser set multipart boundary; do not set Content-Type manually.
    const response = await this.post<CaminoMemberImportRun>(url, formData);
    return response.data;
  }

  public async getCaminoMemberImportReport(churchId: string, importId: string): Promise<Blob> {
    const url = `/api/v1/churches/${churchId}/camino-member-imports/${importId}/report`;
    return this.getBlob(url);
  }
}

export const caminoService = new CaminoService();
